import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const PaymentCancel = () => {
  const { t } = useLang();
  return (
  <div className="min-h-screen flex items-center justify-center bg-secondary/50 px-5">
    <div className="w-full max-w-md bg-card border border-border rounded-2xl shadow-xl p-8 text-center" data-testid="payment-cancel">
      <XCircle size={52} className="mx-auto text-muted-foreground mb-4" />
      <h1 className="text-xl font-extrabold text-foreground">{t("pcx.checkoutCancelled")}</h1>
      <p className="text-sm text-muted-foreground mt-1 mb-6">{t("pcx.noWorriesYouHave")}</p>
      <Link to="/premium" className="inline-block bg-[#16a34a] hover:bg-[#15803d] text-white font-semibold px-6 py-2.5 rounded-xl transition-colors">{t("pcx.backToPremium")}</Link>
    </div>
  </div>
);
}


export default PaymentCancel;
